var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{},[_c('div',{staticClass:"flex items-center justify-between"},[_c('div',{staticClass:"text-primary text-3xl mb-7"},[_vm._v(_vm._s(_vm.title))])]),_c('TutorialsFiles')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }